import { render, staticRenderFns } from "./Escalations.vue?vue&type=template&id=44880008&scoped=true&"
import script from "./Escalations.vue?vue&type=script&lang=js&"
export * from "./Escalations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44880008",
  null
  
)

export default component.exports